import React from "react";
import LayoutPage from "../../hoc/LayoutPage/LayoutPage";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { YEAR, shortName } from "../../constants";
import qrPay from "../../assets/26/fees/qr-pay.png";

function Fees() {
  return (
    <LayoutPage>
      <div>
        <Box fontWeight={800}>
          <Typography variant="h3" align="center" paragraph component="h1">
            Правила оплаты организационных взносов
          </Typography>
        </Box>

        <Box>
          <ul style={{ listStyleType: "decimal" }}>
            <li>
              <Typography variant="body1" paragraph>
                Организационный взнос для участников конференции равен 3000
                руб.; участие студентов и аспирантов бесплатное.
              </Typography>
            </li>
            <li>
              <Typography variant="body1" paragraph>
                Тезисы докладов и статьи будут представлены к опубликованию
                только при условии поступления оргвзноса.
              </Typography>
            </li>
            <li>
              <Typography variant="body1" paragraph>
                Сканированную копию квитанции об оплате оргвзноса следует
                отправить по адресу оргкомитета ufa.mat.sh@mail.ru . При
                невозможности оплаты в банке Вы можете оплатить оргвзнос
                непосредственно в УУНиТ во время регистрации (об этом следует
                сообщить оргкомитету не позднее
                <strong> 20 сентября {YEAR} г.</strong>).
              </Typography>
            </li>
          </ul>

          <Typography variant="h5" align="center" paragraph component="h2">
            <strong>Реквизиты организации для оплаты оргвзноса:</strong>
          </Typography>
          <Typography variant="body1">
            Наименование организации в платежных документах: ООО «ВинТех»
          </Typography>
          <Typography variant="body1">ИНН: 0278107476</Typography>
          <Typography variant="body1">
            Расчетный счет № <strong>40702810120000146597</strong> в ООО "Банк
            Точка"
          </Typography>
          <Typography variant="body1">
            Кор. счет: 30101810745374525104
          </Typography>
          <Typography variant="body1">БИК 044525104</Typography>
          <Typography variant="body1" paragraph>
            В назначении платежа <strong>ОБЯЗАТЕЛЬНО!</strong> указать: Ф.И.О.,
            город, за участие в конференции «{shortName}», без налога (НДС).
          </Typography>

          <Typography variant="h5" align="center" paragraph component="h2">
            <strong>Оплата оргвзноса возможна также через СБП/QR код :</strong>
          </Typography>
          <Box mb={3} display="flex" justifyContent="center">
            <img
              src={qrPay}
              alt="QR-код для оплаты оргвзноса"
              style={{ maxWidth: "280px", width: "100%", height: "auto" }}
            />
          </Box>
          <Typography variant="body1">
            При оплате по СБП организаторам, возможно, потребуется у
            отправителя уточнить информацию по платежу (ФИО, город).
          </Typography>
        </Box>
      </div>
    </LayoutPage>
  );
}

export default Fees;
